import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "./context/LanguageContext";
import Home from "./pages/Home";
import ServiceDetail from "./pages/ServiceDetail";
import Portfolio from "./pages/Portfolio";
import Equipment from "./pages/Equipment";
import Careers from "./pages/Careers";
import CareersSuccess from "./pages/CareersSuccess";
import AdminCareers from "./pages/AdminCareers";
import AdminContacts from "./pages/AdminContacts";
import Infrastructure from "./pages/Infrastructure";
import { PrivacyPolicy, Terms } from "./pages/Legal";
import { ChatBot } from "./components/ChatBot";
import { CookieBanner } from "./components/CookieBanner";
import { ReadingProgress } from "./components/ReadingProgress";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/equipamentos" element={<Equipment />} />
            <Route path="/infraestruturas" element={<Infrastructure />} />
            <Route path="/portfolio" element={<Portfolio />} />
            {/* Legacy route for the old service detail — redirects to the
                new dedicated infrastructure page. */}
            <Route
              path="/servicos/mastros-torres"
              element={<Navigate to="/infraestruturas" replace />}
            />
            <Route path="/servicos/:slug" element={<ServiceDetail />} />
            <Route path="/carreiras" element={<Careers />} />
            <Route path="/carreiras/recebida" element={<CareersSuccess />} />
            <Route path="/admin/carreiras" element={<AdminCareers />} />
            <Route path="/admin/contactos" element={<AdminContacts />} />
            <Route path="/politica-privacidade" element={<PrivacyPolicy />} />
            <Route path="/termos" element={<Terms />} />
          </Routes>
          <ReadingProgress />
          <ChatBot />
          <CookieBanner />
          <Toaster richColors position="top-center" />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
